import { IconButton } from 'design-system-web';

export default IconButton;
